export enum SIDE_BAR_TYPE {
  STORY = 'story'
}
